module.exports = __webpack_public_path__ + "assets/img/05.instance-start.066ad1d3.png";